/**
 * Modal Component Styles
 */

import { mode } from '../../system/color-mode';

export const modalStyles = {
  baseStyle: (props) => ({
    overlay: {
      bg: 'blackAlpha.600',
      zIndex: 'modal',
    },
    dialogContainer: {
      display: 'flex',
      zIndex: 'modal',
      justifyContent: 'center',
      alignItems: props.isCentered ? 'center' : 'flex-start',
      overflow: props.scrollBehavior === 'inside' ? 'hidden' : 'auto',
    },
    dialog: {
      borderRadius: 'lg',
      bg: mode('white', 'gray.700')(props),
      color: 'inherit',
      my: props.isCentered ? 'auto' : '16',
      zIndex: 'modal',
      boxShadow: mode('lg', 'dark-lg')(props),
    },
    header: {
      px: 6,
      py: 4,
      fontSize: 'xl',
      fontWeight: 'semibold',
    },
    closeButton: {
      position: 'absolute',
      top: 2,
      right: 3,
    },
    body: {
      px: 6,
      py: 2,
      flex: 1,
      overflow: props.scrollBehavior === 'inside' ? 'auto' : undefined,
    },
    footer: {
      px: 6,
      py: 4,
      display: 'flex',
      justifyContent: 'flex-end',
      gap: 3,
    },
  }),

  sizes: {
    xs: {
      dialog: { maxW: 'xs' },
    },
    sm: {
      dialog: { maxW: 'sm' },
    },
    md: {
      dialog: { maxW: 'md' },
    },
    lg: {
      dialog: { maxW: 'lg' },
    },
    xl: {
      dialog: { maxW: 'xl' },
    },
    '2xl': {
      dialog: { maxW: '2xl' },
    },
    '3xl': {
      dialog: { maxW: '3xl' },
    },
    '4xl': {
      dialog: { maxW: '4xl' },
    },
    '5xl': {
      dialog: { maxW: '5xl' },
    },
    '6xl': {
      dialog: { maxW: '6xl' },
    },
    full: {
      dialog: { maxW: '100vw', minH: '100vh', my: 0, borderRadius: 0 },
    },
  },

  defaultProps: {
    size: 'md',
    isCentered: false,
    scrollBehavior: 'outside',
  },
};

export default modalStyles;
